// icon-button — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    height: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    outline: none;
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }

  :host([size="xs"]) {
    width: var(--run-icon-button-size-xs, var(--run-size-touch-xs, 28px));
    height: var(--run-icon-button-size-xs, var(--run-size-touch-xs, 28px));
  }
  :host([size="sm"]) {
    width: var(--run-icon-button-size-sm, var(--run-size-touch-sm, 36px));
    height: var(--run-icon-button-size-sm, var(--run-size-touch-sm, 36px));
  }
  :host([size="md"]) {
    width: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
    height: var(--run-icon-button-size-md, var(--run-size-touch-md, 44px));
  }
  :host([size="lg"]) {
    width: var(--run-icon-button-size-lg, var(--run-size-touch-lg, 52px));
    height: var(--run-icon-button-size-lg, var(--run-size-touch-lg, 52px));
  }

  :host([data-disabled]) {
    opacity: var(--run-icon-button-disabled-opacity, var(--run-opacity-state-disabled, 0.38));
    pointer-events: none;
  }

  :host(:focus-visible) {
    outline: 1px dashed var(--run-wf-border);
    outline-offset: var(--run-icon-button-focus-ring-offset, var(--run-space-focus-offset, 2px));
  }

  :host(:focus:not(:focus-visible)) {
    outline: none;
  }

  [part="button"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
    border: 1px dashed var(--run-wf-border);
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }
`;

export function render(host) {
  const { icon, label, size, variant, disabled, loading } = host;

  const disabledAttr = disabled ? ' disabled' : '';
  const ariaLabelAttr = label ? ` aria-label="${label}"` : '';

  const innerContent = loading
    ? `<run-spinner part="spinner" size="${size}" aria-hidden="true"></run-spinner>`
    : `<run-icon part="icon" name="${icon}" size="${size}" aria-hidden="true"></run-icon>`;

  host.shadowRoot.innerHTML = `
    <run-button
      part="button"
      variant="${variant}"
      size="${size}"${disabledAttr}${ariaLabelAttr}
    >${innerContent}</run-button>
  `;
}